import { Link } from 'react-router-dom';
import { appConfig } from '@/lib/config';

export function Footer() {
  return (
    <footer className="mt-auto border-t border-white/5 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-surface-500 text-sm">
          © {new Date().getFullYear()} {appConfig.name}. {appConfig.tagline}
        </p>
        <div className="flex gap-6 text-sm text-surface-500">
          <Link to="/about" className="hover:text-white transition-colors">
            About
          </Link>
          <Link to="/privacy" className="hover:text-white transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-white transition-colors">
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
}
